// CustomPaper.tsx

import { Paper, PaperProps } from "@mui/material";
import React, { ReactNode } from "react";

type Props = {
  children?: ReactNode;
  disablePadding?: boolean; // 👈 new optional prop
} & PaperProps; // Merge with PaperProps to include style prop

export default function CustomPaper({ children, disablePadding = false, ...props }: Props) {
  return (
    <Paper
      {...props} // Spread the props to allow passing additional PaperProps
      sx={{
        maxWidth: "100%",
        background: "inherit",
        boxShadow: "none",
        ...(disablePadding
          ? {} // 👈 if true → remove padding
          : {
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "24px",
              paddingBottom: "30px",
              "@media (max-width: 768px)": {
                paddingLeft: "10px",
                paddingRight: "10px",
              },
            }),
        ...props.sx, // Allow overriding styles
      }}
    >
      {children}
    </Paper>
  );
}


// below code is commented for remove the padding on company branch dashboard 



// import { Paper } from "@mui/material";

// import React, { ReactNode } from "react";

// type Props = {
//   children?: ReactNode;
// };

// export default function CustomPaper({ children }: Props) {
//   return (
//     <Paper
//       sx={{
//         maxWidth: "100%",
//         paddingLeft:'50px',
//         paddingRight:'50px',
//         background:'inherit',
//         boxShadow:'none',
//         paddingTop:'30px',
//         paddingBottom:'40px',
//         "@media (max-width: 768px)": {
//           paddingLeft:'10px',
//         paddingRight:'10px',
//       },
//       }}
//     >
//       {children}
//     </Paper>
//   );
// }
